<template>
  <div class="flex flex-col items-center gap-4">
    <div
      class="shadow-sm mx-auto mt-4 lg:mt-6 rounded-full max-w-[100px]"
    >
      <img
        width="400"
        height="400"
        :src="`/img/people/${image_name}`"
        :alt="name"
        class="rounded-full"
      >
    </div>

    <LayoutP class="text-center">
      <b>{{ name }}</b><br>
      {{ title }}
    </LayoutP>
  </div>
</template>

<script lang="ts" setup>
const { data: { spokesperson: { name, title, image_name } } } = getData()
</script>
